<div class="row justify-content-between">
    <div class="col d-none d-sm-block">
        <h1 class="view-name">
            {{ 'projects.pages.list.title' | translate }}
        </h1>
    </div>
</div>

<div class="row mt-2" *ngIf="isLoaded">
    <app-project-filters
        class="col-sm-3"
        [ngClass]="{ 'projects-filters scroller': isInitiated && !isOnMobile }"
        [areFiltersOpened]="areFiltersOpened"
        [canSeeAllCommunitiesFilter]="canSeeAllCommunitiesFilter"
        [canSeeOrganizationSkillsFilter]="canSeeOrganizationSkillsFilter"
        (closed)="onFiltersClosed()"
        (ready)="onFiltersReady()"
        (selectionChanged)="onFiltersSelectionChanged()"
        #projectFilters
    >
    </app-project-filters>

    <div class="col-12 col-sm-9">
        <div class="row d-flex flex-wrap-reverse">
            <div class="col ml-2 mb-2" style="min-width: 50%">
                <app-custom-search
                    placeholderText="{{ 'projects.pages.list.search.searchTitle' | translate }}"
                    customSearchName="filterOrganisationsByName"
                    (searchTextChanged)="onProjectSearchTextChanged($event)"
                >
                </app-custom-search>
            </div>
            <div *ngIf="canCreateProject" class="col-auto d-block mb-2 mr-4 action-buttons d-flex align-items-center">
                <div class="col-auto d-block d-sm-none mt-sm-1">
                    <button pButton (click)="openFilters()">
                        <em class="icon icon-filter d-sm-inline d-md-none"></em>
                    </button>
                </div>
                <button routerLink="/profile/my-projects" pButton class="p-button-outlined left-select-button">
                    <span class="d-sm-inline">{{ 'projects.pages.list.myProjects' | translate }}</span>
                </button>
                <button routerLink="/projects/create" pButton icon="pi pi-plus" class="right-select-button"></button>
            </div>
        </div>

        <div id="content-list">
            <app-infinite-scroll (scrolled)="onScroll()" class="project-list">
                <app-project-details-card *ngFor="let project of projects" [project]="project"> </app-project-details-card>
            </app-infinite-scroll>
            <div *ngIf="!projectsLoaded">
                <wudo-spinner></wudo-spinner>
            </div>
        </div>

        <div class="row">
            <app-no-result class="col-12" *ngIf="projectsLoaded && projects.length === 0"></app-no-result>
        </div>
    </div>
</div>
